import { Inject, Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { ApiUrlService } from '@core/services/common/api-url.service';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class ContactFormService {

  constructor(
    private httpClient: HttpClient,
    private apiUrlService: ApiUrlService,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  sendMessage(path: string, data: any, withPageUrlParam = false, typ_block_form_id) {
    data['typ_block_form'] = typ_block_form_id;
    const pageUrlParam = withPageUrlParam ?
      `?pageUrl=${this.document.location.pathname}`
      : '';
    const url = this.apiUrlService.getApiUrl() + path + pageUrlParam;
    return this.httpClient
      .post(url, data, {
        headers: new HttpHeaders({'Content-Type': 'application/json'}),
      })
      .pipe(
        catchError((message) => throwError(message))
      );
  }
}
